import { createNamespace, isDef, addUnit } from '../utils';
import Divider from '../divider';
import Rate from '../rate';
import Button from '../button';
import Icon from '../icon';
import Tag from '../tag';
import Avatar from '../avatar';
import Row from '../row';

var _createNamespace = createNamespace('doctor-card'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    avatarOffsetTop: [Number, String],
    avatarFigure: {
      type: [String, Number],
      default: 1
    },
    avatarSize: {
      type: [Number, String],
      default: 50
    },
    avatarRadius: {
      type: [Number, String],
      default: 4
    },
    showOnline: Boolean,
    online: Boolean,
    name: String,
    nameColor: String,
    title: String,
    hospitalLevel: String,
    hospital: String,
    department: String,
    skill: String,
    skillTag: Array,
    praiseNum: Number,
    responseTime: String,
    receiveNum: Number,
    consultNum: Number,
    score: Number,
    buttonText: String,
    showDefaultText: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    clickCard: function clickCard() {
      event.stopPropagation();
      this.$emit('clickCard');
    },
    clickButton: function clickButton() {
      event.stopPropagation();
      this.$emit('clickButton');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var slots = this.slots;
    var genAvatar = h("div", {
      "class": bem('avatar'),
      "style": {
        marginTop: addUnit(this.avatarOffsetTop),
        height: addUnit(this.avatarSize)
      }
    }, [slots('avatar') || h(Avatar, {
      "attrs": {
        "figure": this.avatarFigure,
        "size": this.avatarSize,
        "radius": this.avatarRadius
      }
    }), this.showOnline && h("div", {
      "class": bem('online-tag', {
        online: this.online
      })
    }, [h("div", {
      "class": bem('online-text')
    }, [this.online ? '在线' : '离线'])])]);
    var genBase = h(Row, {
      "attrs": {
        "type": "flex",
        "align": "center",
        "justify": "space-between"
      }
    }, [h("div", [isDef(this.name) && h("span", {
      "class": bem('name'),
      "style": {
        color: this.nameColor
      }
    }, [this.name]), isDef(this.title) && h("span", {
      "class": bem('title')
    }, [this.title])]), h("div", [this.slots('corner')])]);
    var genUnit = (isDef(this.hospitalLevel) || isDef(this.hospital) || isDef(this.department)) && h("div", {
      "class": bem('unit')
    }, [isDef(this.hospitalLevel) && h(Tag, {
      "attrs": {
        "plain": true,
        "size": "small",
        "color": "#6E6E6E"
      },
      "class": bem('level-tag')
    }, [this.hospitalLevel]), isDef(this.hospital) && h("span", {
      "class": bem('hospital')
    }, [this.hospital]), isDef(this.department) && h("span", {
      "class": bem('department')
    }, [this.department])]);
    var genSkill = isDef(this.skillTag) ? h("div", {
      "class": bem('skill', 'tag')
    }, [h(Icon, {
      "attrs": {
        "name": "good-job",
        "color": "#B5B8B6"
      }
    }), this.skillTag.map(function (item) {
      return h(Tag, {
        "attrs": {
          "plain": false,
          "round": true,
          "text-color": "#666666"
        },
        "class": bem('skill-tag')
      }, [item]);
    })]) : isDef(this.skill) ? h("div", {
      "class": [bem('skill'), 'van-multi-ellipsis--l1']
    }, [this.showDefaultText ? '擅长：' : '', this.skill]) : '';
    var genDesc = (isDef(this.praiseNum) || isDef(this.responseTime)) && h("div", {
      "class": bem('description')
    }, [isDef(this.praiseNum) && h("span", [this.showDefaultText ? '好评数&nbsp;' : '', this.praiseNum, this.showDefaultText ? '人' : '']), isDef(this.praiseNum) && isDef(this.responseTime) && h("i", {
      "class": bem('gap')
    }, ["|"]), isDef(this.responseTime) && h("span", [this.showDefaultText ? '响应速度&nbsp;' : '', this.responseTime])]);
    var genFooter = slots('footer') || (isDef(this.receiveNum) || isDef(this.consultNum) || isDef(this.score) || this.buttonText) && h("div", {
      "class": bem('footer')
    }, [h(Divider, {
      "attrs": {
        "dashed": true,
        "margin": 8
      }
    }), h(Row, {
      "attrs": {
        "type": "flex",
        "align": "center",
        "justify": "space-between"
      }
    }, [isDef(this.receiveNum) && h("div", [this.showDefaultText ? '接诊量 ' : '', this.receiveNum]), isDef(this.consultNum) && h("div", [this.showDefaultText ? '已有' : '', h("span", {
      "class": bem('consult-num')
    }, [this.consultNum]), this.showDefaultText ? '人咨询' : '']), isDef(this.score) && h("div", [h(Rate, {
      "attrs": {
        "void-icon": "star",
        "void-color": "#eee",
        "allow-half": true,
        "size": 12,
        "readonly": true
      },
      "model": {
        value: _this.score,
        callback: function callback($$v) {
          _this.score = $$v;
        }
      }
    }), h("span", {
      "class": "margin-left6"
    }, [this.score])]), this.buttonText && h(Button, {
      "attrs": {
        "type": "warning",
        "size": "small"
      },
      "on": {
        "click": this.clickButton
      }
    }, [this.buttonText])])]);
    return h("div", {
      "attrs": {
        "role": "doctor-card"
      },
      "class": bem(),
      "on": {
        "click": this.clickCard
      }
    }, [genAvatar, h("div", {
      "class": bem('wrapper')
    }, [genBase, genUnit, genSkill, genDesc, genFooter])]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/doctor-card/index.js
// module id = null
// module chunks = 